import { render } from "./FilterableSortablePage.vue?vue&type=template&id=d33443de&scoped=true"
import script from "./FilterableSortablePage.vue?vue&type=script&lang=js"
export * from "./FilterableSortablePage.vue?vue&type=script&lang=js"

import "./FilterableSortablePage.vue?vue&type=style&index=0&id=d33443de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d33443de"]])

export default __exports__